import React from "react";

import { BsGrid1X2Fill, BsPeopleFill } from "react-icons/bs";
import { MdOutlineTravelExplore } from "react-icons/md";
import { FaHouseUser } from "react-icons/fa";
import { MdPlace } from "react-icons/md";
import { IoIosPricetags } from "react-icons/io";
import { Link, useLocation } from "react-router-dom";
import { MdOutlineContentPaste } from "react-icons/md";
import { VscFeedback } from "react-icons/vsc";
import { FaRegImages } from "react-icons/fa";
import { GiJourney } from "react-icons/gi";

const css = `
  .sidebar-list-item.active {
  background-color: rgba(255, 255, 255, 0.2); /* Highlight color */
  font-weight: bold; /* Optional: for emphasis */
}
`;
function Sidebar({ openSidebarToggle, OpenSidebar }) {
  const location = useLocation();
  const currentPath = location.pathname;
  return (
    <>
      <style>{css}</style>
      <aside
        id="sidebar"
        className={openSidebarToggle ? "sidebar-responsive" : ""}
      >
        <div className="sidebar-title">
          <div className="sidebar-brand">
            <img
              src="../images/logo.png"
              alt="Logo"
              style={{ width: "200px", height: "90px", marginRight: "10px" }}
            />
          </div>
          <span className="icon close_icon" onClick={OpenSidebar}>
            X
          </span>
        </div>

        <ul className="sidebar-list">
          <li
            className={`sidebar-list-item ${currentPath === "/dashboard" ? "active" : ""
              }`}
          >
            <Link to="/dashboard" className="sidebar-link">
              <BsGrid1X2Fill className="icon" /> Dashboard
            </Link>
          </li>
          <li
            className={`sidebar-list-item ${currentPath === "/userManagement" ? "active" : ""
              }`}
          >
            <Link to="/userManagement" className="sidebar-link">
              <FaHouseUser className="icon" /> User Management
            </Link>
          </li>
          <li
            className={`sidebar-list-item ${currentPath === "/journeyManagement" ? "active" : ""
              }`}
          >
            <Link to="/journeyManagement" className="sidebar-link">
              <GiJourney className="icon" /> Journey Management
            </Link>
          </li>
          <li
            className={`sidebar-list-item ${currentPath === "/placesManagement" ? "active" : ""
              }`}
          >
            <Link to="/placesManagement" className="sidebar-link">
              <MdPlace className="icon" /> Places Management
            </Link>
          </li>

          <li
            className={`sidebar-list-item ${currentPath === "/tagManagement" ? "active" : ""
              }`}
          >
            <Link to="/tagManagement" className="sidebar-link">
              <IoIosPricetags className="icon" /> Tags Management
            </Link>
          </li>

          <li
            className={`sidebar-list-item ${currentPath === "/contentManagement" ? "active" : ""
              }`}
          >
            <Link to="/contentManagement" className="sidebar-link">
              <MdOutlineContentPaste className="icon" /> Content Management
            </Link>
          </li>
          {/* 
          <li className="sidebar-list-item">
            <Link to="" className="sidebar-link">
              <BsPeopleFill className="icon" /> Payments Overview
            </Link>
          </li>
          <li className="sidebar-list-item">
            <Link to="" className="sidebar-link">
              <BsPeopleFill className="icon" /> Reports and Analytic
            </Link>
          </li> */}
          <li
            className={`sidebar-list-item ${currentPath === "/helpAndSupport" ? "active" : ""
              }`}
          >
            <Link to="/helpAndSupport" className="sidebar-link">
              <BsPeopleFill className="icon" /> Help and Support
            </Link>
          </li>
          <li
            className={`sidebar-list-item ${currentPath === "/UploadedImage" ? "active" : ""
              }`}
          >
            <Link to="/UploadedImage" className="sidebar-link">
              <FaRegImages className="icon" /> Uploaded Images
            </Link>
          </li>
          <li
            className={`sidebar-list-item ${currentPath === "/ratingAndReview" ? "active" : ""
              }`}
          >
            <Link to="/ratingAndReview" className="sidebar-link">
              <VscFeedback className="icon" /> Rating & Review
            </Link>
          </li>
          {/* <li
            className={`sidebar-list-item ${
              currentPath === "/backgroundImage" ? "active" : ""
            }`}
          >
            <Link to="/backgroundImage" className="sidebar-link">
              <FaRegImages className="icon" /> Background Image
            </Link>
          </li> */}
        </ul>
      </aside>
    </>
  );
}

export default Sidebar;
